import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import Button from "aldoo-ra/Button"
import Typography from "aldoo-ra/Typography"
import { navigate } from "vike/client/router"
import parse from "html-react-parser"

const NoSubscriptionsCard = () => {
  const handleViewPlans = (link) => {
    if (link?.[0]?.url) {
      navigate(link[0].url)
    }
  }

  return (
    <CMSRender
      contentType="NoSubscriptionsCard"
      renderItem={(card) => {
        return (
          <div className="account-card shadow-custom_card">
            {/* Title */}
            <Typography 
              variant="subtitle_32_accent" 
              className="text-text mt-0 md:mb-7"
            >
              {card.title}
            </Typography>

            {/* Description */}
            <div className="mb-8">
              <Typography variant="info_16" className="text-text">
                {parse(card.description)}
              </Typography>
            </div>

            {/* CTA Button */}
            <Button
              variant="primary_s"
              onClick={() => handleViewPlans(card.plans_btn[0]?.link)}
            >
              {card.cta}
            </Button>
          </div>
        )
      }}
    />
  )
}

export default NoSubscriptionsCard
